import React from 'react';
import OpsDetailTabs from './OpsDetailTabs';
import OpsOrganizationRole from './OpsOrganizationRole';
import OpsPasswordRecovery from './OpsPasswordRecovery';
import OpsSubscriptionSettings from './OpsSubscriptionSettings';
import useOpsUserDetails from './useOpsUserDetails';

export default function OpsUserDetailsPage({ id, tab, onTabChange, onOpenOrganization, plans, formatDate, onRefresh }) {
  const { user, error, retry } = useOpsUserDetails(id);
  if (error) return <div role="alert">{error} <button onClick={retry} className="underline">Retry</button></div>;
  if (!user) return <p role="status">Loading user…</p>;
  const tabs = [{ id: 'profile', label: 'Profile' }, { id: 'access', label: 'Access' }, { id: 'activity', label: 'Activity' }];
  if (!user.organization_id) tabs.push({ id: 'subscription', label: 'Subscription' });
  const activeTab = tabs.some(item => item.id === tab) ? tab : 'profile';
  return <div className="space-y-5">
    <header>
      <h2 className="text-2xl font-bold text-gray-900">User Details</h2>
      <p className="text-gray-600 break-all">{user.name || user.email} · {user.email}</p>
      {user.organization_id && <button onClick={() => onOpenOrganization(user)}
        className="text-blue-700 hover:underline mt-2">View organization</button>}
    </header>
    <div className="admin-card p-6">
      <OpsDetailTabs value={activeTab} onChange={onTabChange} tabs={tabs}>{section => <>
        {section === 'profile' && <dl className="grid sm:grid-cols-2 gap-6">
          <div><dt className="text-sm text-gray-500">Name</dt><dd>{user.name || '—'}</dd></div>
          <div><dt className="text-sm text-gray-500">Email</dt><dd className="break-all">{user.email}</dd></div>
          <div><dt className="text-sm text-gray-500">User ID</dt><dd className="break-all font-mono text-sm">{user.id}</dd></div>
          <div><dt className="text-sm text-gray-500">Registered</dt><dd>{formatDate(user.created_at)}</dd></div>
        </dl>}
        {section === 'access' && <div className="space-y-4">
          <h3 className="font-semibold">Account access</h3>
          <p>Account status: <strong>{user.is_active === false ? 'Inactive' : 'Active'}</strong></p>
          <p>Last login: {formatDate(user.last_login)}</p>
          {user.organization_id ? <>
            <OpsOrganizationRole user={user} />
            <p className="text-sm text-gray-500">Organization membership and seat access are shown in the organization’s Team section.</p>
          </> : <p>This account does not belong to an organization.</p>}
          <OpsPasswordRecovery user={user} />
        </div>}
        {section === 'activity' && <div className="grid sm:grid-cols-3 gap-4">
          <div className="rounded-lg bg-blue-50 p-4"><p>Total Tests</p>
            <strong className="text-2xl">{user.total_tests_generated ?? user.total_tests ?? 0}</strong></div>
          <div className="rounded-lg bg-green-50 p-4"><p>This Month</p>
            <strong className="text-2xl">{user.monthly_usage ?? ((user.recent_api_tests || 0) + (user.recent_flow_tests || 0))}</strong></div>
          <div className="rounded-lg bg-purple-50 p-4"><p>Last Login</p><strong>{formatDate(user.last_login)}</strong></div>
        </div>}
        {section === 'subscription' && <OpsSubscriptionSettings user={user} plans={plans} onRefresh={onRefresh} />}
      </>}</OpsDetailTabs>
    </div>
  </div>;
}
